import { render, staticRenderFns } from "./ProjectForumTopic.vue?vue&type=template&id=594e081a&scoped=true"
import script from "./ProjectForumTopic.vue?vue&type=script&lang=ts"
export * from "./ProjectForumTopic.vue?vue&type=script&lang=ts"
import style0 from "./ProjectForumTopic.vue?vue&type=style&index=0&id=594e081a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594e081a",
  null
  
)

export default component.exports